import { Outlet, NavLink, useNavigate } from "react-router-dom";
import useAxiosPrivate from "./useAxiosPrivate";

const Layout = () => {
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();

    const logout = async () => {
        try {
            await axiosPrivate.get("/logout");
            navigate("/login");
        } catch(err) {
            console.log(err);
        }
    }

    return (
        <div>
            <nav className="bg-white border-b border-gray-200 shadow-md">
                <div className="container mx-auto px-4">
                    <div className="flex justify-between items-center py-3">
                        <div className="flex space-x-6">
                            <NavLink to="/dashboard" className={({ isActive }) => isActive ? "text-blue-600 font-medium" : "text-gray-700 font-medium hover:text-blue-600 transition"}>
                                Dashboard
                            </NavLink>
                            <NavLink to="/products" className={({ isActive }) => isActive ? "text-blue-600 font-medium" : "text-gray-700 font-medium hover:text-blue-600 transition"}>
                                Products
                            </NavLink>
                            <NavLink to="/lists" className={({ isActive }) => isActive ? "text-blue-600 font-medium mr-6" : "text-gray-700 font-medium hover:text-blue-600 transition mr-6"}>
                                Lists
                            </NavLink>
                            <NavLink to="/account-users" className={({ isActive }) => isActive ? "text-blue-600 font-medium mr-6" : "text-gray-700 font-medium hover:text-blue-600 transition mr-6"}>
                                Users
                            </NavLink>
                            <NavLink to="/sms" className={({ isActive }) => isActive ? "text-blue-600 font-medium" : "text-gray-700 font-medium hover:text-blue-600 transition"}>
                                SMS Templates
                            </NavLink>
                            <NavLink to="/messages" className={({ isActive }) => isActive ? "text-blue-600 font-medium" : "text-gray-700 font-medium hover:text-blue-600 transition"}>
                                Messages
                            </NavLink>
                        </div>
                        <button onClick={logout} className="text-gray-500 font-medium hover:text-red-600 transition ml-6">Logout</button>
                    </div>
                </div>
            </nav>
            <div className="container mx-auto px-4 py-6">
                <Outlet />
            </div>
        </div>
    )
}

export default Layout;